export const CASE_TYPE = {
    CATALOG_ALL: "ALL",
    CATALOG_MY_DATASETS: "MY",
    CATALOG_RESULTS: "RESULTS",
    CATALOG_PROCESSING: "PROCESSING",
    CATALOG_OBTAINED_DATASETS: "OBTAINED",
    CATALOG_PUBLIC_DATASETS: "PUBLIC",
  };